<template>
    <div class="loading">
        <div class="loading-content">
            <b-spinner label="Spinning" small class="mr-2"></b-spinner>
            {{ $t('common.loading') }}...
        </div>
    </div>
</template>

<script>
export default {
    name: 'Loading',
};
</script>

<style lang="scss" scoped>
@import 'Loading';
</style>
